import { render, staticRenderFns } from "./DxViewClient.vue?vue&type=template&id=2a083a2b&scoped=true&"
import script from "./DxViewClient.vue?vue&type=script&lang=js&"
export * from "./DxViewClient.vue?vue&type=script&lang=js&"
import style0 from "./DxViewClient.vue?vue&type=style&index=0&id=2a083a2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a083a2b",
  null
  
)

export default component.exports